export default "__VITE_ASSET__BKCQ7uA5__"